export class Warehouse {
	public id?: number;
	public code?: string;
	public description?: string;

	constructor(init?: Partial<Warehouse>) {
		Object.assign(this, init);
	}
}
